import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { D, JAKARTA, inputStyle, Chip } from "./ui";

// Kelola akun walikota (dipakai di halaman Pengaturan → Walikota)
export function MayorPanel({ token }) {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ username: "", password: "", city_id: "" });
  const [edit, setEdit] = useState(null);
  const [msg, setMsg] = useState("");

  const load = () => api.listMayors(token).then(d => setRows(d.mayors || [])).catch(e => setMsg(e.message));
  useEffect(() => { load(); }, []); // eslint-disable-line

  async function submit(e) {
    e.preventDefault();
    setMsg("");
    try {
      if (edit) {
        await api.patchMayor(token, edit, Object.fromEntries(Object.entries(form).filter(([, v]) => v)));
      } else {
        await api.createMayor(token, form);
      }
      setForm({ username: "", password: "", city_id: "" });
      setEdit(null);
      load();
    } catch (err) { setMsg(err.message); }
  }

  async function seed() {
    const d = await api.seedMayors(token).catch(e => ({ error: e.message }));
    setMsg(d.error || `Seed: ${d.created?.length || 0} akun dibuat`);
    load();
  }

  async function del(username) {
    if (!window.confirm(`Hapus ${username}?`)) return;
    await api.deleteMayor(token, username).catch(e => setMsg(e.message));
    load();
  }

  return (
    <div data-testid="mayor-panel" style={{ fontFamily: JAKARTA }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 200 }}>
          <h3 style={{ margin: 0, fontSize: 20, fontWeight: 800, letterSpacing: -0.5, color: D.ink }}>Kelola Walikota</h3>
          <p style={{ margin: "4px 0 0", fontSize: 12.5, color: D.sub }}>Satu akun walikota per kota. Setiap walikota hanya bisa mengedit kotanya sendiri. Nama tampilan kota diatur di bagian <b>Nama Kota</b>.</p>
        </div>
        {msg && <Chip testid="mayor-msg">{msg}</Chip>}
        <button data-testid="seed-mayors-btn" onClick={seed}
          style={{ display: "inline-flex", alignItems: "center", gap: 7, padding: "10px 20px", background: D.dark, color: "#fff", border: 0, borderRadius: 99, fontSize: 13, fontWeight: 700, fontFamily: JAKARTA, transition: "opacity 0.15s", cursor: "pointer" }}
          onMouseEnter={e => e.currentTarget.style.opacity = "0.85"} onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
          Seed 10 Akun Default
        </button>
      </div>

      <form onSubmit={submit} data-testid="mayor-form"
        style={{ display: "flex", gap: 10, marginBottom: 18, flexWrap: "wrap", background: "#fff", padding: 18, borderRadius: 26, boxShadow: "0 8px 22px rgba(20,20,20,0.05)" }}>
        {[
          ["mayor-username", "username", "Username", !!edit, true],
          ["mayor-password", "password", edit ? "Password baru (opsional)" : "Password", false, !edit],
          ["mayor-city-id", "city_id", "city_id (mis. kediri)", false, !edit],
        ].map(([tid, key, ph, dis, req]) => (
          <input key={tid} data-testid={tid} value={form[key]} onChange={e => setForm({ ...form, [key]: e.target.value })}
            placeholder={ph} disabled={dis} required={req}
            style={{ ...inputStyle, width: "auto", flex: 1, minWidth: 150 }} />
        ))}
        <button data-testid="mayor-submit" type="submit"
          style={{ padding: "11px 22px", background: D.blue, color: "#fff", border: 0, borderRadius: 99, fontWeight: 700, fontSize: 13, fontFamily: JAKARTA, transition: "opacity 0.15s", cursor: "pointer" }}
          onMouseEnter={e => e.currentTarget.style.opacity = "0.85"} onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
          {edit ? "Simpan" : "Tambah"}
        </button>
        {edit && <button type="button" data-testid="mayor-cancel-edit" onClick={() => { setEdit(null); setForm({ username: "", password: "", city_id: "" }); }}
          style={{ padding: "11px 18px", background: "#fff", color: D.ink, border: `1.5px solid ${D.line}`, borderRadius: 99, fontWeight: 700, fontSize: 13, fontFamily: JAKARTA, cursor: "pointer" }}>Batal</button>}
      </form>

      <div style={{ background: "#fff", borderRadius: 26, padding: "18px 22px", boxShadow: "0 8px 22px rgba(20,20,20,0.05)", overflowX: "auto" }}>
        <table data-testid="mayor-table" style={{ width: "100%", minWidth: 560, borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: "left", color: D.sub, fontSize: 11 }}>
              <th style={{ padding: "6px 8px", fontWeight: 700 }}>Username</th>
              <th style={{ padding: "6px 8px", fontWeight: 700 }}>Kota</th>
              <th style={{ padding: "6px 8px", fontWeight: 700 }}>city_id</th>
              <th style={{ padding: "6px 8px", fontWeight: 700 }}>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(m => (
              <tr key={m.username} style={{ borderTop: `1px solid ${D.line}` }}>
                <td style={{ padding: "10px 8px", fontWeight: 700, color: D.ink }}>{m.username}</td>
                <td style={{ padding: "10px 8px", color: D.sub }}>{m.city_name}</td>
                <td style={{ padding: "10px 8px", color: D.sub }}>{m.city_id}</td>
                <td style={{ padding: "10px 8px", display: "flex", gap: 6 }}>
                  <button data-testid={`edit-${m.username}`} onClick={() => { setEdit(m.username); setForm({ username: m.username, password: "", city_id: m.city_id }); }}
                    style={{ padding: "6px 14px", background: D.blueSoft, color: D.blue, border: 0, borderRadius: 99, fontSize: 12, fontWeight: 700, fontFamily: JAKARTA, cursor: "pointer" }}>Edit</button>
                  <button data-testid={`delete-${m.username}`} onClick={() => del(m.username)}
                    style={{ padding: "6px 14px", background: "#fff", color: D.danger, border: `1.5px solid ${D.dangerSoft}`, borderRadius: 99, fontSize: 12, fontWeight: 700, fontFamily: JAKARTA, cursor: "pointer" }}>Hapus</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {rows.length === 0 && <p style={{ color: D.sub, fontSize: 13, margin: "12px 8px 4px" }}>Belum ada akun walikota.</p>}
      </div>
    </div>
  );
}
